import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {AddBeneficiaryService} from '../../../../shared/services/nso-data-portal/add-services/add-beneficiary-service';
import {FormHelperService} from '../../../../shared/services/person/form-helper-service';
import * as _ from 'lodash';
import {BeneficiaryData} from '../../../../shared/types/nso-data-portal/census-data';
import {BeneficiaryRestService} from '../../../../shared/services/nso-data-portal/rest-services/beneficiary-rest.service';

@Component({
  selector: 'wsd-add-beneficiary',
  templateUrl: './add-beneficiary.component.html',
  styleUrls: ['./add-beneficiary.component.css']
})
export class AddBeneficiaryComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  types: string[];
  filteredTypes = [];

  subTypes: string[];
  filteredSubTypes = [];

  beneficiary: BeneficiaryData;

  beneficiaryForm: UntypedFormGroup;

  display = false;

  constructor(private addBeneficiaryService: AddBeneficiaryService,
              private beneficiaryService: BeneficiaryRestService,
              private formHelper: FormHelperService,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.beneficiaryForm = this.fb.group({
      beneficiaryCategoryType: ['', [Validators.required, Validators.maxLength(255)]],
      beneficiaryCategorySubType: ['', [Validators.required, Validators.maxLength(255)]],
      beneficiaryCategoryCategory: ['', [Validators.required, Validators.maxLength(255)]],
      beneficiaryCategoryDescription: ['', Validators.maxLength(4096)],
      beneficiaryCategoryGuidance: ['', Validators.maxLength(4096)]
    });
    this.addBeneficiaryService.messageSent$.subscribe(
      (beneficiary: any) => {
        this.beneficiary = beneficiary;
        this.beneficiaryForm.reset();
        this.beneficiaryForm.patchValue(beneficiary);
        this.display = true;
      }
    );
    this.beneficiaryService.getBeneficiaryTypes()
      .subscribe(res => this.types = res);
    this.beneficiaryService.getBeneficiarySubTypes()
      .subscribe(res => this.subTypes = res);
  }

  save() {
    this.formHelper.validateAllFormFields(this.beneficiaryForm);
    if (this.beneficiaryForm.invalid) {
      return;
    }
    _.assign(this.beneficiary, this.beneficiaryForm.value);
    this.display = false;
    this.onSave.emit(this.beneficiary);
  }

  filterTypes(event) {
    this.filteredTypes = [];
    for (const type of this.types) {
      if (type.toLowerCase().indexOf(event.query.toLowerCase()) > -1) {
        this.filteredTypes.push(type);
      }
    }
  }

  filterSubTypes(event) {
    this.filteredSubTypes = [];
    for (const type of this.subTypes) {
      if (type.toLowerCase().indexOf(event.query.toLowerCase()) > -1) {
        this.filteredSubTypes.push(type);
      }
    }
  }
}
